import {DomainEvent} from './DomainEvent';
import {DeletedEntity} from '../resources/DeletedEntity';

export class TeamDeleted extends DomainEvent<DeletedEntity> {}
